import React, { useState } from "react";
import { Box, Checkbox } from "@mui/material";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

export default function CustomCheckBox({
  checked,
  handleSelect,
  disabled = false,
}) {
  return (
    <Box>
      <Checkbox
        disabled={disabled}
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon />}
        name="curate"
        color="primary"
        checked={checked}
        onChange={handleSelect}
      />
    </Box>
  );
}
